<div class="bg-gray-100 rounded-2xl rounded-tl-md p-5">
    <!-- Header -->
    <div class="flex items-center mb-3">
        <span class="text-2xl mr-2">{{ getIcon() }}</span>
        <span class="text-[24px] font-remote font-[600] text-gray-900">{{ title }}</span>
    </div>

    <!-- Valor monetário em destaque -->
    <div class="text-[36px] font-remote font-[700] text-emerald-600 mb-3">
        {{ getFormattedValue() }}
    </div>

    <!-- Description -->
    <p class="text-[14px] font-inter text-gray-600 leading-relaxed">
        {{ description }}
    </p>

    <!-- Footer -->
    <spotlight-response-footer
        [executionTimeMs]="executionTimeMs">
    </spotlight-response-footer>
</div>
